import { render } from "./EditTestNoteForm.vue?vue&type=template&id=1077f02d&scoped=true"
import script from "./EditTestNoteForm.vue?vue&type=script&lang=js"
export * from "./EditTestNoteForm.vue?vue&type=script&lang=js"

import "./EditTestNoteForm.vue?vue&type=style&index=0&id=1077f02d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1077f02d"]])

export default __exports__